import { useEffect, useState } from 'react';
import { Cradle } from '@solo/app-core';
import { toast } from 'react-toastify';
import { Flex, WorldMapWithMarkers } from '@/app/ui';
import { useCradle } from '@/app/contexts';
import { QuantityPerCountryWithCoordinates } from '@/app/ui/organisms/WorldMapWithMarkers/WorldMapWithMarkers';
import { useBlocState } from '@/app/hooks';

const PlaysByCountry = () => {
  const { statisticsBloc, authBloc, territoryBloc } = useCradle<Cradle>();
  const authState = useBlocState(authBloc);
  const [topCountries, setTopCountries] = useState<QuantityPerCountryWithCoordinates[]>([]);

  async function getTopSongsByCountry() {
    if (authState.kind !== 'AuthenticatedAuthState') return;

    try {
      const countries = await statisticsBloc.getCountries();
      const countryPlaysWithCoordinates: QuantityPerCountryWithCoordinates[] = [];
      await Promise.all(
        countries.map(async (countryData) => {
          const coordinates = await territoryBloc.getTerritoryCoordinates({
            country: countryData.country,
          });

          if (!coordinates) {
            return;
          }

          countryPlaysWithCoordinates.push({
            countryData: { quantity: countryData.plays },
            coordinates,
          });
        }),
      );

      setTopCountries(countryPlaysWithCoordinates);
    } catch (error) {
      toast.error('Something went wrong when loading country plays.');
    }
  }
  useEffect(() => {
    getTopSongsByCountry();
  }, []);

  return (
    <Flex.Container
      flexDirection="column"
      style={{ width: '100%', marginTop: '-30px', marginLeft: '-30px' }}
    >
      <WorldMapWithMarkers markers={topCountries} />
    </Flex.Container>
  );
};

export default PlaysByCountry;
